import { render, staticRenderFns } from "./editWorkList.vue?vue&type=template&id=0dfe1d20&scoped=true"
import script from "./editWorkList.vue?vue&type=script&lang=js"
export * from "./editWorkList.vue?vue&type=script&lang=js"
import style0 from "./editWorkList.vue?vue&type=style&index=0&id=0dfe1d20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfe1d20",
  null
  
)

export default component.exports